import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateConfig as _updateConfig, getNetworkInfo, listConfig } from "@/api/configurationlist";
import { progressControl } from '@/api/particulars';
import { cloneDeep, isEqual } from 'lodash';
import { Form } from 'element-ui';
import networkInfo from "../networkInfo/index";
import { addConfig } from "../../../../../api/task";
import { channelOptions, htmodeOptions } from "./wifiConfig";
export default {
  props: ["deviceDid", "deviceSn"],
  components: {
    networkInfo: networkInfo
  },
  data: function data() {
    return {
      channelOptions: channelOptions,
      // 信道选项
      htmodeOptions: htmodeOptions,
      // 频宽选项
      //模式
      ModeList: [{
        label: 'sta',
        value: 'sta'
      }, {
        label: "ap",
        value: "ap"
      }],
      deviceSettingForm: {
        channel: 'auto',
        htmode: 'HT20',
        index: '',
        sname: ''
      },
      deviceDataCopy: {},
      //加密方式
      EncryptionList: [{
        label: 'No Encryption',
        value: 'none'
      }, {
        label: 'WPA-PSK',
        value: 'psk'
      }, {
        label: 'WPA2-PSK',
        value: 'psk2'
      }, {
        label: 'WPA-PSK/WPA2-PSK Mixed Mode',
        value: 'psk-mixed'
      }],
      //算法
      AlgorithmList: [{
        label: this.$t('lang.wifi.auto'),
        value: 'auto'
      }, {
        label: this.$t('lang.wifi.CCMP'),
        value: 'ccmp'
      }, {
        label: this.$t('lang.wifi.TKIP'),
        value: 'tkip'
      }, {
        label: this.$t('lang.wifi.CCMP_TKIP'),
        value: 'tkip+ccmp'
      }],
      //loading层
      loading: true,
      UpData: true,
      //密钥验证
      KeyColor: false,
      // 网络接口基本信息
      networkInfo: [],
      timer: null,
      protoOptions: {
        static: this.$t('lang.wifi.static'),
        l2tp: 'L2TP',
        pptp: 'PPTP',
        dhcp: 'DHCP'
      },
      // wifi是否存在客户端模式
      STA: false,
      copyData: [],
      wifiData: []
    };
  },
  watch: {
    STA: {
      immediate: true,
      handler: function handler() {
        var _this = this;

        clearInterval(this.timer);

        if (this.STA) {
          this.fetchNetworkInfo();
          this.timer = setInterval(function () {
            _this.fetchNetworkInfo();
          }, 10000);
        }
      }
    }
  },
  activated: function activated() {
    var _this2 = this;

    this.fetchNetworkInfo();
    this.timer = setInterval(function () {
      _this2.fetchNetworkInfo();
    }, 10000);
  },
  deactivated: function deactivated() {
    clearInterval(this.timer);
  },
  beforeDestroy: function beforeDestroy() {
    clearInterval(this.timer);
  },
  mounted: function mounted() {
    this.getConfig();
  },
  methods: {
    // 获取wifi
    getConfig: function getConfig() {
      var _this3 = this;

      this.loading = true;
      listConfig(this.deviceSn, this.deviceDid, [{
        section: "wifi-iface",
        config: "wireless",
        options: [{
          option: "mode"
        }, {
          option: "ssid"
        }, {
          option: "hidden"
        }, {
          option: "wmm"
        }, {
          option: "encryption"
        }, {
          option: "key"
        }, {
          option: "disabled"
        }]
      }, {
        section: "wifi-device",
        config: "wireless",
        options: [{
          option: "channel"
        }, {
          option: "htmode"
        }]
      }]).then(function (res) {
        if (res.data.code === 0) {
          var data = res.data.data;

          if (data.mess) {
            data.mess.forEach(function (ele) {
              if (ele.section === 'wifi-iface') {
                _this3.wifiData = ele.s_objects;

                if (_this3.wifiData.length > 0) {
                  _this3.wifiData.map(function (item) {
                    if (item.options.mode === 'sta') {
                      item.options.wmm = false;
                    } else {
                      if (item.options.wmm === '0') {
                        item.options.wmm = false;
                      } else {
                        item.options.wmm = true;
                      }
                    } // item.options.wmm = item.options.wmm === '0' ? false : true


                    item.options.hidden = item.options.hidden === '1' ? true : false;

                    if (item.options.key.length < 8) {
                      _this3.$set(item.options, 'KeyColor', true);
                    } else {
                      _this3.$set(item.options, 'KeyColor', false);
                    }

                    if (item.options.mode == 'sta') {
                      _this3.STA = true;
                    }

                    _this3.$set(item.options, 'viewPWD', false);
                  });
                }
              } else if (ele.section === 'wifi-device') {
                _this3.deviceSettingForm.channel = ele.s_objects[0].options.channel;
                _this3.deviceSettingForm.htmode = ele.s_objects[0].options.htmode;
                _this3.deviceSettingForm.index = ele.s_objects[0].index;
                _this3.deviceSettingForm.sname = ele.s_objects[0].sname;
              }
            });
          }
        }

        _this3.copyData = cloneDeep(_this3.wifiData);
        _this3.deviceDataCopy = cloneDeep(_this3.deviceSettingForm);
        _this3.loading = false;
      }).catch(function (err) {
        _this3.$message({
          message: _this3.$t('lang.request.timeout'),
          type: "warning"
        });
      });
    },
    keyChange: function keyChange(val, row) {
      if (val.length < 8) {
        this.$set(row.options, 'KeyColor', true);
      } else {
        this.$set(row.options, 'KeyColor', false);
      }
    },
    setPWDView: function setPWDView(row) {
      this.$set(row.options, 'viewPWD', !row.options.viewPWD);
    },
    //禁用与开启切换
    OnOff: function OnOff(row) {
      row.options.disabled = row.options.disabled == '' ? '1' : '';
    },
    //保存配置
    updateConfig: function updateConfig() {
      var _this4 = this;

      if (!isEqual(this.copyData, this.wifiData) || !isEqual(this.deviceSettingForm, this.deviceDataCopy)) {
        var isSave = true;
        var dataCopy = cloneDeep(this.wifiData); // 判断秘钥是否符合条件，不符合则返回，符合直接提交

        dataCopy.map(function (item, index) {
          if (item.options.encryption !== 'none' && item.options.encryption !== '') {
            if (item.options.KeyColor == true || item.options.key === '') {
              // 为空代表秘钥输入框没有发生变化但是为空（初始值）
              isSave = false;
            }
          } else {
            item.options.key = '';
          }

          item.options.hidden = item.options.hidden === true ? '1' : '';
          item.options.wmm = item.options.wmm === true ? '' : '0';

          _this4.$set(item, 'section', 'wifi-iface');

          _this4.$set(item, 'config', 'wireless');

          _this4.$set(item, 'action', 0);

          _this4.$set(item, 'index', [item.index || index]);

          if (item.index[0] === undefined) item.index[0] = 0;
          delete item.options.KeyColor;
          delete item.options.viewPWD;
          delete item.sname;
        });

        if (isSave) {
          var device = {
            // sname: this.deviceSettingForm.sname,
            index: [this.deviceSettingForm.index ? this.deviceSettingForm : 0],
            section: "wifi-device",
            config: "wireless",
            action: 0,
            options: {
              channel: this.deviceSettingForm.channel,
              htmode: this.deviceSettingForm.htmode
            }
          };
          dataCopy.push(device);
          this.loading = true;

          _updateConfig(this.deviceSn, this.deviceDid, dataCopy).then(function (res) {
            if (res.data.data.result === 1) {
              _this4.$message({
                showClose: true,
                message: _this4.$t('lang.ConfigSetting.Successfulconfiguration'),
                type: "success"
              }); //重启wifi进程


              progressControl([{
                process: "wifi",
                action: "restart",
                type: 1
              }], _this4.deviceDid.toString(), _this4.deviceSn).then(function (res) {
                //获取新的配置数据
                _this4.getConfig();

                _this4.fetchNetworkInfo();

                _this4.loading = false;
              });
            } else {
              _this4.$message({
                showClose: true,
                message: _this4.$t('lang.ConfigSetting.Configurationerror'),
                type: 'warning'
              });

              return;
            }
          });
        } else {
          return;
        }
      } else {
        this.$message({
          showClose: true,
          message: this.$t('lang.ConfigSetting.Nochangesmade'),
          type: 'warning'
        });
        return;
      }
    },
    // 获取lan接口基本信息
    fetchNetworkInfo: function fetchNetworkInfo() {
      var _this5 = this;

      getNetworkInfo(this.deviceDid, this.deviceSn, ['wwan']).then(function (res) {
        _this5.networkInfo = res.data.data.mess['wwan'];
      }).catch(function () {});
    },
    //计算毫秒数
    getDuration: function getDuration(msd) {
      var time = msd;

      if (null != time && "" != time) {
        if (time > 60 && time < 60 * 60) {
          time = parseInt(time / 60.0) + this.$t("lang.particulars.minutes") + parseInt((parseFloat(time / 60.0) - parseInt(time / 60.0)) * 60) + this.$t("lang.particulars.seconds");
        } else if (time >= 60 * 60 && time < 60 * 60 * 24) {
          time = parseInt(time / 3600.0) + this.$t("lang.particulars.hours") + parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + this.$t("lang.particulars.minutes") + parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) - parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + this.$t("lang.particulars.seconds");
        } else if (time >= 60 * 60 * 24) {
          time = parseInt(time / 3600.0 / 24) + this.$t("lang.particulars.Day") + parseInt((parseFloat(time / 3600.0 / 24) - parseInt(time / 3600.0 / 24)) * 24) + this.$t("lang.particulars.hours") + parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) + this.$t("lang.particulars.minutes") + parseInt((parseFloat((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60) - parseInt((parseFloat(time / 3600.0) - parseInt(time / 3600.0)) * 60)) * 60) + this.$t("lang.particulars.seconds");
        } else {
          time = parseInt(time) + this.$t("lang.particulars.seconds");
        }
      }

      return time;
    },
    // 计算流量
    getTraffic: function getTraffic(byte) {
      var kb = 0;
      var mb = 0;
      var g = 0;
      var result = '';

      if (byte > 1024) {
        kb = byte / 1024;
      }

      if (kb > 1024) {
        mb = kb / 1024;
      }

      if (mb > 1024) {
        g = mb / 1024;
      }

      if (g !== 0) {
        result = Math.floor(g * 10) / 10 + 'G';
      } else if (mb !== 0) {
        result = Math.floor(mb * 10) / 10 + 'M';
      } else if (kb !== 0) {
        result = Math.floor(kb * 10) / 10 + 'K';
      } else if (byte !== 0) {
        result = byte + 'B';
      } else {
        result = '0';
      }

      console.log('result');
      console.log(result);
      return result;
    }
  }
};